@let isMobile = isMobile$ | async;
<pxc-carousel-navigation
  [carouselMode]="CarouselNavigationMode.INSIDE"
  [itemsCount]="thumbnailsPerPage"
  [max]="medias.length"
  [showControls]="showControls"
  [(index)]="currentThumbnailIndex">
  <div class="absolute right-2 top-2 z-20 flex items-center justify-end" data-testid="tile-actions">
    <ng-content />
    <ng-content select="[tile-actions]" />
  </div>
  @if (draggingMedia()) {
    <div class="pointer-events-none absolute inset-0 z-1">
      <pxc-sequence-media class="w-full" [media]="draggingMedia()" />
    </div>
  }
  <tui-carousel
    #carousel
    cdkDropList
    cdkDropListOrientation="vertical"
    class="w-full"
    [cdkDropListConnectedTo]="['drawer-list']"
    [cdkDropListSortingDisabled]="true"
    [max]="lastPageIndex"
    [min]="0"
    [pxcCarouselIndex]="currentPageIndex"
    (indexChange)="showPage($event)">
    <ng-template let-page tuiItem>
      @let idx = firstMediaIndexOfPage(page);
      @let media = medias[idx];
      @if (media) {
        <div
          cdkDrag
          class="w-full cursor-pointer"
          [attr.data-testid]="'drag-' + idx"
          [cdkDragData]="media"
          [cdkDragDisabled]="media.type === MediaType.VIDEO || isMobile"
          (cdkDragEnded)="dragEnd()"
          (cdkDragStarted)="dragStart(media)"
          (click)="emitMediaClicked(media, idx)">
          <ng-template cdkDragPlaceholder>
            <pxc-sequence-media class="w-full opacity-50" [media]="media" />
          </ng-template>
          <ng-container [ngTemplateOutlet]="sequenceMedia" />
          <pxc-sequence-media *cdkDragPreview class="w-32 opacity-50" [media]="draggingMedia()" />
        </div>
        <ng-template #sequenceMedia>
          <pxc-sequence-media class="w-full" data-testid="thumbnail" syncBadgeVariant="detailed" [media]="media">
            <div
              class="pointer-events-none absolute left-0 top-0 z-5 h-full w-full bg-linear-to-b from-black/50 via-transparent"></div>
            <pxc-quick-modules
              class="absolute left-2 top-2 z-10 flex"
              size="s"
              [displayType]="'icon'"
              [media]="media"
              [target]="thumbnailQuickModulesTarget" />
          </pxc-sequence-media>
        </ng-template>
      }
    </ng-template>
  </tui-carousel>
</pxc-carousel-navigation>
